import Vue from "vue";
import axios from "axios";

export default {
  name: "CustomerComplaint",
  props: ["dataObj"],
  data: function () {
    return {
      appData: {},
      complaintTypes: [],
      complaintSubtypes: [],
      connections: [],

      suggestedActivity: "",
      isOwnerOrTenant: false,
    };
  },
  created() {
    this.appData = this.dataObj.complaint;
    this.complaintTypes = this.$store.state.csAppsOfflineMode
      ? this.dataObj.complaintTypes
      : this.appData.complaintTypes;
    this.complaintSubtypes = this.$store.state.csAppsOfflineMode
      ? this.dataObj.complaintSubtypes
      : this.appData.complaintSubtypes;

    if (this.complaintTypes.length >= 1) {
      this.appData.complaintTypeId =
        this.appData.complaintTypeId == null
          ? this.complaintTypes[0].value
          : this.appData.complaintTypeId;
    }

    if (!this.$store.state.csAppsOfflineMode) {
      this.connections = this.appData.connections;

      if (this.appData.isOwner && this.appData.propertiesList.length >= 1) {
        this.appData.propertyId =
          this.appData.propertyId == null
            ? this.appData.propertiesList[0].value
            : this.appData.propertyId;
      }

      if (!this.appData.isOwner && this.appData.propertiesList.length >= 1) {
        this.appData.propertyId =
          this.appData.propertyId == null
            ? this.appData.propertiesList[0].value
            : this.appData.propertyId;
      }

      if (this.connections.length >= 1) {
        this.appData.connectionId =
          this.appData.connectionId == null
            ? this.connections[0].value
            : this.appData.connectionId;
      }
    }

    if (this.appData.isOwner) this.isOwnerOrTenant = "isOwner";
    else if (this.$parent.$parent.settings.orgShortName == "LSDB")
      this.isOwnerOrTenant = "isOwner";
    else this.isOwnerOrTenant = "isTenant";

    this.changeOwnerOrTenant(
      this.dataObj.complaint.isOwner ? "isOwner" : "isTenant"
    );

    //console.log("ddd", this.$parent.$parent.settings.orgName);
  },
  watch: {
    "appData.complaintTypeId": function (val) {
      this.getComplaintSubtypes();
      this.getSuggestedActivity();
    },
  },
  computed: {
    trimmedConnections: function () {
      let propSelected = [];
      if (
        this.appData.isOwner &&
        this.appData.propertiesList &&
        this.appData.propertiesList.length > 0
      )
        propSelected = this.appData.propertiesList.filter(
          (s) => s.value == this.appData.propertyId
        );
      else if (
        !this.appData.isOwner &&
        this.appData.propertiesList &&
        this.appData.propertiesList.length > 0
      )
        propSelected = this.appData.propertiesList.filter(
          (s) => s.value == this.appData.propertyId
        );

      if (propSelected.length > 0)
        return this.connections.filter(
          (s) => s.group.id == propSelected[0].value
        );
    },
  },
  methods: {
    propertySelected(prop) {
      this.appData.connectionId = null;
    },
    changeOwnerOrTenant(val) {
      if (
        (this.dataObj.complaint.isOwner && val == "isOwner") ||
        (!this.dataObj.complaint.isOwner && val != "isOwner")
      )
        return;

      this.dataObj.complaint.isOwner = val == "isOwner";
      this.appData.isOwner = this.dataObj.complaint.isOwner;

      this.appData.connectionId = null;
      this.appData.propertyId = null;
    },
    getComplaintSubtypes() {
      var parameter = {
        ApplicationId: this.dataObj.appId,
        ComplaintTypeId: this.appData.complaintTypeId,
        ComplaintSubTypeId: -1,
      };

      this.$store.state.notifier
        .asyncBlock(
          axios.post(
            "/CustomerComplaintActivity/GetComplaintSubTypes",
            parameter
          ),
          (response) => {
            //console.log("response", response);
            this.appData.complaintSubtypes = "";
            this.complaintSubtypes = response.data.items;
            if (
              this.complaintSubtypes.length > 0 &&
              (this.appData.complaintSubtypeId == null ||
                this.appData.complaintSubtypeId < 0)
            ) {
              this.appData.complaintSubtypeId = this.complaintSubtypes[0].value;
            }
            //else
            //  this.appData.complaintSubtypeId ='';
          }
        )
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    getSuggestedActivity() {
      this.$store.state.notifier
        .asyncBlock(
          axios.get(
            "/CustomerComplaintActivity/GetSuggestedActivities?complaintTypeId=" +
              this.appData.complaintTypeId
          ),
          (response) => {
            //console.log("response", response);
            this.appData.suggestedActivities = response.data;
            let selectedActivity = this.appData.suggestedActivities.filter(
              (s) => s.selected == true
            );
            if (selectedActivity != null && selectedActivity.length > 0)
              this.suggestedActivity = selectedActivity[0].text;
            else this.suggestedActivity = "";
          }
        )
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    getPropertyLocation() {
      var parameter = {
        ApplicationId: this.dataObj.appId,
        ApplicationKey: 0,
        PropertyId: this.appData.propertyId,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post("/CustomerComplaintActivity/GetPropertyLocation", parameter),
        (response) => {
          this.appData.problemLocation = response.data.item;
        },
        (err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
      );
    },
  },
};
